import {
    NOTIFICATION_SEND,
    NOTIF_CLEAR
} from '../constants/notifications';

export const initialState = {
    notificationText: ''
};

export function notificationReducer( state = initialState, action ) {

    switch ( action.type ) {

        case NOTIFICATION_SEND:

            return Object.assign( {}, state, {
                notificationText: action.notificationText
            });

        case NOTIF_CLEAR:

            return Object.assign( {}, state, {
                notificationText: ''
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js